import React from "react";
import { Link } from "react-router-dom";
import MarketingLayout from "../components/MarketingLayout.js";

function DeleteData() {
  return (
    <MarketingLayout>
      <div style={{ maxWidth: "900px", margin: "0 auto", padding: "0 20px" }}>
        <h1>Data Deletion</h1>
        <p><strong>Last updated:</strong> March 2025</p>

        <h2>What data we may hold</h2>
        <ul>
          <li>Account information (name, email, login details)</li>
          <li>Chat history</li>
          <li>Uploaded or generated files</li>
          <li>Usage and analytics data</li>
          <li>Payment information</li>
        </ul>

        <h2>How to request deletion</h2>
        <p>
          To request deletion of your data, email us from the account email address at:
        </p>

        <p>
          <a href="mailto:hello@zolaid.com?subject=Data%20deletion%20request">
            hello@zolaid.com
          </a>
        </p>

        <p>
          Use the subject <strong>"Data deletion request"</strong> and specify what you would
          like deleted (for example: "all my data" or "account and chat history only").
        </p>

        <h2>What happens next</h2>
        <p>
          We may verify your identity before processing the request. Your data will be
          deleted or anonymized within the legally required timeframe (typically within
          30 days). Some information may be retained where required by law.
        </p>

        <h2>Your other rights</h2>
        <p>
          You may also request access, correction, restriction, or objection to how your
          data is processed. Contact us at:
        </p>

        <p>
          <a href="mailto:hello@zolaid.com">hello@zolaid.com</a>
        </p>

        <h2>Related pages</h2>
        <ul>
          <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
          <li><Link to="/TermsOfService">Terms of Service</Link></li>
          <li><Link to="/Contact">Contact</Link></li>
        </ul>

        <div style={{ marginTop: "40px", padding: "20px", background: "#f6f6f6", borderRadius: "8px" }}>
          <p>
            Ready to delete your data?
          </p>

          <a
            href="mailto:hello@zolaid.com?subject=Data%20deletion%20request"
            style={{ fontWeight: "bold" }}
          >
            Email us to request deletion
          </a>
        </div>
      </div>
    </MarketingLayout>
  );
}

export default DeleteData;
